module.exports = __webpack_public_path__ + "img/centro_aprendizaje.8e8b855d.png";